import moment from "moment/moment";
import * as _ from "lodash";

export const convertDate = (date) => {
    return moment(date).format('YYYY.MM.DD');
}

export const formatCurrency = (value) => {
    return !Number.isInteger(value) && _.isEmpty(value) ? "" : 
        value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "’") + "₮";
}

export const delay = ms => new Promise(resolve => setTimeout(resolve, ms))
